export default function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-array/src/permute.js
// module id = ../../../../d3-array/src/permute.js
// module chunks = 4